import { LoaderFunctionArgs } from "react-router-dom";
import { getEventService } from "services/events.service";

/**
 * Loader for /event-details/:eventId route that validates the event exists.
 * Throws a 404 response if the event is not found.
 */
export async function eventDetailsGuardLoader({ params }: LoaderFunctionArgs) {
  const eventId = params.eventId;

  if (!eventId) {
    throw new Response("Event not found", { status: 404 });
  }

  try {
    const event = await getEventService(eventId);

    if (!event || !event.id) {
      throw new Response("Event not found", { status: 404 });
    }

    return null;
  } catch (error) {
    if (error instanceof Response) {
      throw error;
    }
    throw new Response("Event not found", { status: 404 });
  }
}
